import React, { useRef } from 'react';
import { TextField, Box } from '@mui/material';

const OTPInput = ({ value, setValue }) => {
  const inputsRef = useRef([]);

  const handleChange = (val, index) => {
    const newValue = [...value];
    newValue[index] = val.slice(-1);
    setValue(newValue);

    // Move focus to the next input if value entered
    if (val && index < inputsRef.current.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !value[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <Box display="flex" justifyContent="space-between" gap={1} width="100%">
      {[0, 1, 2, 3,4,5].map((i) => (
        <TextField
          key={i}
          inputRef={(el) => (inputsRef.current[i] = el)}
          inputProps={{ maxLength: 1, inputMode: 'numeric', style: { textAlign: 'center', padding: '12px 0' } }}
          value={value[i]}
          onChange={(e) => handleChange(e.target.value, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          sx={{ minWidth: 0, flex: '1 1 0' }}
        />
      ))}
    </Box>
  );
};

export default OTPInput;
